import PopupToBottomSheet from '../components/PopupToBottomSheet';

import useCheckLimitedEditions from './components/LimitedEditionHooks';
import LimitedEditionsAvailable from './components/LimitedEditionsAvailable';
import LimitedEditionsNotAvailable from './components/LimitedEditionsNotAvailable';

import './index.css';

function LimitedEditionPopupContent({ close, onRequest, dataNeeded, loading, requested, approved }) {
  
  const limitedEditionsValidation = useCheckLimitedEditions(dataNeeded);

  if(limitedEditionsValidation.error || dataNeeded.typeOfArtwork === "Gallery owned") {
    return (
      <LimitedEditionsNotAvailable close={close}/>
    );
  } else {
    return (
      <LimitedEditionsAvailable
        limitedEditions={limitedEditionsValidation}
        close={close} 
        onRequest={onRequest}
        loading={loading}
        requested={requested}
        approved={approved}
      />
    );
  }
}

export default function LimitedEditionPopup({ open, close, onRequest, loading=false, requested=false, dataNeeded, approved }) {
  return (
    <>
      <PopupToBottomSheet 
        className="limited-edition-popup-to-bottom-sheet" 
        open={open} 
        close={close} 
        popupOptions={{ opacity: true }}
      >
        <LimitedEditionPopupContent 
          close={close} 
          onRequest={onRequest} 
          dataNeeded={dataNeeded} 
          loading={loading} 
          requested={requested}
          approved={approved}
        />
      </PopupToBottomSheet>
    </>
  );
}
